import { create } from 'zustand';
import { authApi } from '../api/auth';
import { isCurrentTokenExpired } from '../utils/authUtils';

import { analyticsConsent } from '../lib/analyticsConsent';

const setLoginStatusProperty = (status) => analyticsConsent.setLoginStatus(status);

export const useUserStore = create((set) => ({
  user: null,
  loading: false,
  error: null,
  isAdmin: false,
  isLogin: false,
  initialized: false,

  setUser: (user) => set({ user }),
  clearUser: () => {
    set({ user: null });
    set({ isLogin: false });
    set({ isAdmin: false });
    set({ loading: false });
    set({ error: null });
    localStorage.removeItem('POSTPOP_AUTH_TOKEN');
    setLoginStatusProperty('guest');
  },

  fetchUser: async () => {
    set({ loading: true, error: null });
    try {
      // 토큰이 만료되었는지 미리 확인
      if (isCurrentTokenExpired()) {
        set({ user: null, loading: false, isAdmin: false, isLogin: false, initialized: true });
        return;
      }

      const userData = await authApi.getMe();
      const isLogin = Object.keys(userData.data).length > 0;
      set({ user: userData.data, loading: false });
      set({ isLogin });
      set({ isAdmin: userData.data.role === 'ADMIN' });
      setLoginStatusProperty(isLogin ? 'login' : 'guest');
    } catch (err) {
      set({ user: null, isLogin: false, isAdmin: false, error: err.message, loading: false });
      setLoginStatusProperty('guest');
    } finally {
      set({ initialized: true });
    }
  },
}));
